<h1 mat-dialog-title>
  {{ 'Taxonomy' | transloco }}
</h1>

<div mat-dialog-content>
  <ul class="root">
    <li class="mat-tree-node" [class.active]="!taxonomy.value?.id" (click)="setActiveNode(null)">
      <button emphasis="minimal" size="small" ttButton variant="transparent" [disabled]="true">
        <mat-icon [icon]="'account_tree'" [iconSize]="24" />
      </button>

      {{ 'Root' | transloco }}
    </li>
    <mat-tree class="tree flex-2" [dataSource]="dataSource" [treeControl]="treeControl">
      <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodeToggle
        [class.active]="taxonomy.value?.id === node.id"
        (click)="setActiveNode(node)">
        <li class="mat-tree-node">
          <button disabled="true" emphasis="minimal" size="small" ttButton variant="transparent"></button>
          {{ node.title }}
        </li>
      </mat-tree-node>
      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div [class.active]="taxonomy.value?.id === node.id">
          <div class="mat-tree-node" (click)="setActiveNode(node)">
            <button matTreeNodeToggle type="icon" [attr.aria-label]="'Toggle ' + node.name">
              <mat-icon>
                {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
              </mat-icon>
            </button>
            {{ node.title }}
          </div>
          <ul class="list-container" [class.invisible]="!treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet />
          </ul>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </ul>
</div>
<div class="fx-layout fx-layout-align-end-center" mat-dialog-actions>
  <span class="spacer"></span>
  <button ttButton variant="secondary" (click)="closeDialog()">
    <span>{{ 'Cancel' | transloco }}</span>
  </button>
  <button class="save" ttButton (click)="saveTaxonomy()">
    <span>{{ 'Use' | transloco }}</span>
  </button>
</div>
